module.exports = __webpack_public_path__ + "static/media/folderheart.470fdaa7.svg";